export const formatExcludedItems = (excludedItems, categoryOptions) => {
    if (!Array.isArray(excludedItems) || excludedItems.length === 0) return [];

    if (typeof excludedItems[0] === "string") {
        return excludedItems.map((item) => {
            const option = categoryOptions.find((opt) => opt.value === item);
            return option
                ? { label: option.label, value: option.value }
                : { label: item, value: item };
        });
    }

    if (typeof excludedItems[0] === "object" && excludedItems[0] !== null) {
        return excludedItems.map((item) => item.value);
    }

    return [];
};

export const formatDataForForm = (data, categoryOptions) => {
    const formData = [];

    for (const [key, value] of Object.entries(data)) {
        let formattedValue = value?.value;
        const isBrandConfig = key.includes("categoryBrand");
        if (key === "menuItemsExcluded") {
            formattedValue = formatExcludedItems(value?.value, categoryOptions);
        }
        formData.push({
            field: key,
            dataType: !isBrandConfig ? value?.dataType : null,
            value: !isBrandConfig ? formattedValue : value,
        });
    }

    return formData;
};

export const formatDataForAPI = (data, categoryOptions) => {
    const babbageAccountAttributes = [];

    for (const [key, val] of Object.entries(data)) {
        if (key !== "mainAccountNumber") {
            if (
                key !== "categoryBrandPriorities" &&
                key !== "categoryBrandRestrictions"
            ) {
                let formattedVal = val;
                if (typeof formattedVal === "boolean") {
                    formattedVal = `${formattedVal}`;
                }
                if (key === "excludeMenuItems") {
                    formattedVal = formatExcludedItems(formattedVal, categoryOptions);
                }
                babbageAccountAttributes.push({
                    type: key,
                    value: formattedVal,
                });
            }
        }
    }

    return {
        babbageAccountAttributes,
        babbageAccountCategoryBrandPriorities: data?.categoryBrandPriorities,
        babbageAccountCategoryBrandRestrictions: data?.categoryBrandRestrictions,
    };
};
